import React, {useEffect, useState} from 'react';
import {Route, Switch, useLocation} from 'react-router-dom';

import MainNavBar from './MainNavBar.js';
import MainScreen from './MainScreen.js';
import SurveyTwoPartScreen from './SurveyTwoPartScreen.js';
import LogTwoPartScreen from './LogTwoPartScreen.js';
import AboutMe from './AboutMe.js';
import ContactUs from './ContactUs.js';
import SleepLog from './SleepLog.js';
import PrivacyPolicy from './PrivacyPolicy.js';
import TransLetter from './TransLetter.js';
import ProviderScreen from './ProviderScreen';
import MedBillingScreen from './MedBillingScreen.js';
import MedBillingPrivacyPolicyScreen from './MedBillingPrivacyPolicyScreen.js';
import UnderConstructionScreen from './UnderConstructionScreen.js';

// Using Material-UI v4: https://v4.mui.com/
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';

import {psychApps} from './psychApps.js';

import {UserContext} from './UserContext';
import { useAuthState } from 'react-firebase-hooks/auth';
import {auth} from './firebase.js'

import './App.css';

let theme = createMuiTheme({
  palette: {
    type: "dark",
      primary: {
      main: '#9c27b0',
    },
      secondary: {
      main: '#ea80fc',
    },
  }
});

theme = responsiveFontSizes(theme);

const appItemRoutes = psychApps.map((app)=>{
  if (app.type==="survey") { //Create Routes If App Is A Survey
    return <Route key={app.item} path={`/${app.item.toLowerCase()}`} render={()=><SurveyTwoPartScreen item={app.item}/>}/>;
  }
  if (app.item==="Sleep-Log") { //Send to Sleep Log since it is specialized/not modular like the others
    return <Route key={app.item} path={`/${app.item.toLowerCase()}`} component={SleepLog} />
  } else if (app.type==="log") { //Create Routes If App Is A Log but not Sleep Log
    return <Route key={app.item} path={`/${app.item.toLowerCase()}`} render={()=><LogTwoPartScreen item={app.item}/>}/>;
  }
  return null;
});

const App = () => {
  const location = useLocation(); // LISTEN FOR LOCATION CHANGES
  const [navTitle, setNavTitle] = useState("");

  ///////COOKIE WARNING FUNCTIONALITY//////
  const [cookieAgreed, setCookieAgreed] = useState(()=>localStorage.getItem("cookies-agreed-v0.1")==="true"); // check if already agreed to privacy this time
  const [cookieWarningOpen, setCookieWarningOpen] = useState(false); // privacy dialog boolean

  useEffect(()=>{
    if (!cookieAgreed) {
        handleCookieWarningOpen();
    } else {
        localStorage.setItem("cookies-agreed-v0.1", "true");
    }
  }, [cookieAgreed]); 

  const handleCookieWarningOpen = () => {
    setCookieWarningOpen(true);
  };

  const handleCookieWarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    if (event) {
      event.preventDefault();
    };
    setCookieAgreed(true);
    setCookieWarningOpen(false);
  };

   // SCROLL UP EVERY TIME LOCATION/ROUTER CHANGES + UPDATE NAVBAR TITLE WITH LOC CHANGE
   useEffect(()=>{
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll up when data changes
    if (location.pathname !== "/") { //Update NavBar title depending on location
      setNavTitle("Psych-Apps")
    } else {
      setNavTitle("");
    }
  }, [location]); 

  //LOGIN-DETECTION
  const [user, loading, error] = useAuthState(auth);
  const [loggedInSuccessOpen, setLoggedInSuccessOpen] = useState(user!==null);

  useEffect(()=>{
    if (!user) {
        //console.log("Not connected"); // hide snackbar
        //setLoggedInSuccess(false);
    } else {
        //console.log("Connected"); // show snackbar
        setLoggedInSuccessOpen(true);
    }
  }, [user]); 

  /*const handleLoginSuccessOpen = () => {
    setCookieWarningOpen(true);
  }; */

  const handleLoginSuccessClose  = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    if (event) {
      event.preventDefault();
    };
    setLoggedInSuccessOpen(false);
  };

  return (
      <UserContext.Provider value={{user, loading, error}}>
      <ThemeProvider theme={theme}>  
      <CssBaseline />
      <MainNavBar title={navTitle}/>
      <Switch>
        <Route exact path='/' component={MainScreen} />
        <Route path='/about' component={AboutMe} />
        <Route path='/contact' component={ContactUs} />
        <Route path='/privacy-policy' component={PrivacyPolicy}/>
        <Route path='/provider/trans-letter' component={TransLetter}/>
        <Route path='/provider/med-billing/privacy' component={MedBillingPrivacyPolicyScreen}/>
        <Route path='/provider/med-billing' component={MedBillingScreen}/>
        <Route path='/provider/' component={ProviderScreen}/>
        {appItemRoutes}
        <Route component={UnderConstructionScreen} />
      </Switch>
      <Snackbar open={cookieWarningOpen} onClose={handleCookieWarningClose} message={<React.Fragment>Please note that this website uses cookies that are necessary for it's functionality. To learn more about cookies, please review our <Link onClick={(e)=>e.preventDefault} href="/privacy-policy" target="_blank">Privacy Policy</Link>. Agree to acknowledge and proceed.</React.Fragment>} action={<Button variant="contained" color="primary" onClick={handleCookieWarningClose}>AGREEE</Button>}/>
      <Snackbar open={loggedInSuccessOpen} autoHideDuration={3000} onClose={handleLoginSuccessClose} message="Connected to your account." action={<Button color="primary" onClick={handleLoginSuccessClose}>OK</Button>}/>
    </ThemeProvider>
    </UserContext.Provider>
  );
};

export default App;
